import { cloneComponent, findParentComponent, findComponent, getCellWidth, checkAddWidget } from "@helpers/component.helper";
import { GRID, CELL, WIDGET } from "@model/components/componentMeta.model";

const default_position = {
  top: "0",
  left: "0",
  height: "0",
  width: "0",
}
const state = {
  addComponent: {
    section: {
      sectionID: undefined,
      direction: undefined,
    },
    grid: {
      gridID: undefined,
      sectionID: undefined,
      direction: undefined,
      isFirst: false,
      isLast: false
    },
    widget: {
      cellID: undefined,
      direction: undefined,
      widgetID: undefined,
      attribute: undefined,
      cellWidth: undefined,
      cellAlign: null,
    },
    component: {
      parentID: undefined,
      direction: undefined,
      componentID: undefined,
    },
    slideWidget: {
      slideSectionID: undefined,
      slidePageID: undefined,
      slideContainerID: undefined,
      slideWidgetID: undefined,
      direction: undefined,
      attribute: undefined,
      slideContainerAlign: null,
    },
    widgetInteractive:{
      parentID: undefined,
      attribute : undefined,
      componentsID: undefined,
      componentsIDHover: undefined,
    }
  },
  elHoverID: [],
  elActiveID: [],
  elActiveParentID: [],
  elVisible: [],
  componentsKey: "componentsID",

  settingPanelWdgProductCateActiveId: undefined,
  widgetTableCellActiveId: {
    widgetId: null,
    cellId: [],
    selections: [],
  },
};

const getters = {
  elHoverID: (state) => {
    return state.elHoverID;
  },
  elActiveID: (state) => {
    return state.elActiveID;
  },
  elActiveParentID: (state) => {
    return state.elActiveParentID;
  },
  activeSection: (state, _, rootState) => {
    if (state.elActiveID.includes('component')) {
      if (state.elActiveID.length <= 2) {
        const compIndex = state.elActiveID.indexOf("component");
        return rootState.design.metadata.screen.pages.assets.components[
          state.elActiveID[compIndex + 1]
        ];
      } else {
        return rootState.design.metadata.screen.pages.assets.components[
          state.elActiveID[state.elActiveID.length - 1]
        ];
      }
    } else {
      return {};
    }
  },
  settingPanelWdgProductCateActiveId: (state) => {
    return state.settingPanelWdgProductCateActiveId;
  },
  widgetTableCellActiveId: (state) => {
    return state.widgetTableCellActiveId;
  },
};
const actions = {
  duplicateSection({ commit, dispatch }, { component_id }) {
    dispatch('design/blockloading', {}, { root: true })
    const components =
      this.state.designIframe.metadata.screen.pages.assets.components;
    const { key, object } = cloneComponent({ components, component_id });
    commit("ADD_SECTION", { key, object });

    if(object[key].type == "SLIDE_SECTION") {
      dispatch(
        "designIframe/frame/setSlideSectionActive", {
          component_id: key,
          index: 0
        },
        { root: true }
      );
    } else {
      dispatch("designIframe/frame/setSectionActive", {
          component_id: key,
          name: key,
        },
        { root: true }
      );
    }
    dispatch(
      "designIframe/postToParent",
      {
        func: "component/scrollToId",
        payload: { elementID: key },
      },
      { root: true }
    );
    dispatch("elActive", { elementID: ["component", key] }).then(() => {
      setTimeout(() => dispatch("design/unblockloading", {}, { root: true }), 1500)
    });
  },
  duplicateComponent({ commit, dispatch }, { component_id, parent_id }) {
    const components =
      this.state.designIframe.metadata.screen.pages.assets.components;
    let previousComponent = components[component_id];

    const { key, object } = cloneComponent({ components, component_id });

    previousComponent.style.marginBottom = previousComponent.style.marginTop;

    commit("ADD_COMPONENT", { key, prevKey: component_id, object, parent_id });
    if(object[key].type == "SECTION_GRID") {
      dispatch("designIframe/frame/setCellActive", {
        component_id: object[key].componentsID[0],
        parent_id: key,
      }, { root: true });
    } else if(object[key].id.search(WIDGET.prefixKey) == 0) {
      const gridID = findParentComponent(components,parent_id)[1]
      dispatch("designIframe/frame/setWidgetActive", {
        grid_id: gridID,
        cell_id: parent_id,
        component_id: key,
      }, { root: true });
    }
    dispatch(
      "designIframe/postToParent",
      {
        func: "component/scrollToId",
        payload: { elementID: key },
      },
      { root: true }
    );
    setTimeout(() => dispatch("elActive", { elementID: ["component", key] }), 300);

  },
  removeComponent(
    { commit, dispatch },
    { id, parent_id, shapshot = true, count = 0 }
  ) {
    const components =
      this.state.designIframe.metadata.screen.pages.assets.components;
    if (!parent_id) {
      const parents = findParentComponent(components, id);
      const is_cell = id.search(CELL.prefixKey) == 0;
      parent_id = parents[parents.length - 1];
      if (is_cell) {
        parent_id = parents[parents.length - 2];
      }
    }
    const component = components[id];
    if (component) {
      const childAttr = Object.keys(component).filter(
        (attr) => attr.search("componentsID") > -1
      );
      childAttr.forEach((attr) => {
        const child =
          this.state.designIframe.metadata.screen.pages.assets.components[id] &&
          this.state.designIframe.metadata.screen.pages.assets.components[id][
            attr
          ];
        if (child && Array.isArray(child) && child.length > 0) {
          const child_key = child;
          child_key.forEach((child_id) => {
            dispatch("removeComponent", {
              id: child_id,
              parent_id: id,
              shapshot: false,
            });
          });
        }
        if (child && child.length > 0 && count < 5) {
          dispatch("removeComponent", {
            id,
            parent_id,
            shapshot: false,
            count: count + 1,
          });
        }
      });
    }

    commit("REMOVE_COMPONENT", { id, parent_id });
    if (shapshot) {
      dispatch("elActive", {});
      dispatch("designIframe/snapshot/genSnapshot", {}, { root: true });
    }
  },
  removeSection({ commit, dispatch }, { id }) {
    dispatch('design/blockloading', {}, { root: true })
    const child =
      this.state.designIframe.metadata.screen.pages.assets.components[id] &&
      this.state.designIframe.metadata.screen.pages.assets.components[id]
        .componentsID;
    if (child && Array.isArray(child) && child.length > 0) {
      child.forEach((child_id) => {
        dispatch("removeComponent", {
          id: child_id,
          parent_id: id,
          shapshot: false,
        });
      });
    }
    commit("REMOVE_SECTION", { id });
    dispatch("elActive", {});
    dispatch("designIframe/snapshot/genSnapshot", {}, { root: true }).then(() => {
      setTimeout(() => dispatch("design/unblockloading", {}, { root: true }), 2000)
    })
  },

  addSection({ commit, dispatch }, { key, object }) {
    commit("ADD_SECTION", { key, object });
    if (this.state.designIframe.frame.sectionActive.id == "empty_section") {
      dispatch("designIframe/frame/setSectionActive", {}, { root: true });
    }
    dispatch("designIframe/snapshot/genSnapshot", {}, { root: true });
    dispatch(
      "designIframe/postToParent",
      {
        func: "setMode",
        payload: {},
      },
      { root: true }
    );
    // dispatch('elActive', {})

    if (object[key].type == "SLIDE_SECTION") { // Slide Section
      dispatch("elActive", {
        elementID: ["component", key, object[key].componentsID[0]],
      });
    } else { // Section
      dispatch("elActive", { elementID: ['component', key] });
    }

    dispatch(
      "designIframe/postToParent",
      {
        func: "component/scrollToId",
        payload: { elementID: key },
      },
      { root: true }
    );
  },
  addWidget({ commit, dispatch, state }, { key, object }) {
    const components = this.state.designIframe.metadata.screen.pages.assets.components
    const widgetComponent = Object.values(object)[0]
    if (state.addComponent.widget.cellID) {
      const cellID = state.addComponent.widget.cellID
      const cellWidth = getCellWidth(components, cellID)
      const sectionID = findParentComponent(components,cellID)[0]
      const sectionComponent = findComponent(components,sectionID)
      const isAllow = checkAddWidget(sectionComponent, widgetComponent, cellWidth)
      if (isAllow) {
        if ('alignX' in widgetComponent.style) { // check KEY alignX
          if (
              widgetComponent.type !== "SECTION_WIDGET_TEXT"
            && widgetComponent.type !== "SECTION_WIDGET_COUNTER"
            && widgetComponent.type !== "SECTION_WIDGET_FORM"
            && widgetComponent.type !== "SECTION_WIDGET_CONTACT"
            && widgetComponent.type !== "SECTION_WIDGET_FAQ"
            && widgetComponent.type !== "SECTION_WIDGET_HTML"
            && widgetComponent.type !== "SECTION_WIDGET_QUOTATION_FORM"
          ) {
            widgetComponent.style.alignX = state.addComponent.widget.cellAlign // center
          }
        }
        if ('positionX' in widgetComponent.style) { // check KEY positionX
          widgetComponent.style.positionX = state.addComponent.widget.cellAlign 
        }
        if(widgetComponent.type == "SECTION_WIDGET_LINE_SEPARATE") {
          const cellComponent = findComponent(components,cellID)
          let color = '--tpc-55';
          if(cellComponent.style.backgroundType == "color") {
            if(cellComponent.style.backgroundColor == '--tpc-55' || cellComponent.style.backgroundColor == '--tpc-15') {
              color = '--tpc-11';
            }
            if(cellComponent.style.backgroundColor == '--tpc-11'|| cellComponent.style.backgroundColor == '--tpc-51') {
              color = '--tpc-55';
            }
          }else if(sectionComponent.style.backgroundType == 'color') {
            if(sectionComponent.style.backgroundColor == '--tpc-55'|| cellComponent.style.backgroundColor == '--tpc-15') {
              color = '--tpc-11';
            }
            if(sectionComponent.style.backgroundColor == '--tpc-11'|| cellComponent.style.backgroundColor == '--tpc-51') {
              color = '--tpc-55';
            }
          }
          widgetComponent.style.color = color;
        }
        commit('ADD_WIDGET', { key, object })
        dispatch('designIframe/snapshot/genSnapshot', {}, { root: true })
        dispatch("designIframe/postToParent", {
          func: "setMode",
          payload: {},
        }, { root: true });

        dispatch("designIframe/frame/setFloatFrameActive", {}, { root: true });
        dispatch("designIframe/frame/setFloatFrameHover", {}, { root: true });
        dispatch("designIframe/frame/setSectionHover", {}, { root: true });
        dispatch("designIframe/frame/setSectionActive", {}, { root: true });
        dispatch("designIframe/frame/setSlideSectionHover", {}, { root: true });
        dispatch("designIframe/frame/setSlideSectionActive", {}, { root: true });

        dispatch("elActive", {
          elementID: ["component", widgetComponent.id],
        });

        dispatch("designIframe/frame/setWidgetActive", {
          grid_id: state.elActiveParentID[1],
          cell_id: cellID,
          component_id: key,
        }, { root: true });
      } else {
        dispatch('design/setModal', { name: 'modal-cannot-add-widget' }, { root: true })
      }
    } else if (state.addComponent.slideWidget.slideContainerID) {
        const indexSlidePage = components[state.addComponent.slideWidget.slideSectionID].componentsID.indexOf(state.addComponent.slideWidget.slidePageID)
        const slideSectionID = state.addComponent.slideWidget.slideSectionID;
        if ('alignX' in widgetComponent.style) { // check KEY alignX
          if (
              widgetComponent.type !== "SECTION_WIDGET_TEXT" 
            && widgetComponent.type !== "SECTION_WIDGET_COUNTER" 
            && widgetComponent.type !== "SECTION_WIDGET_FORM" 
            && widgetComponent.type !== "SECTION_WIDGET_CONTACT" 
            && widgetComponent.type !== "SECTION_WIDGET_FAQ"
            && widgetComponent.type !== "SECTION_WIDGET_QUOTATION_FORM" 
          ) {
            widgetComponent.style.alignX = state.addComponent.slideWidget.slideContainerAlign // center
          }
        }
        if ('positionX' in widgetComponent.style) { // check KEY positionX
          widgetComponent.style.positionX = state.addComponent.slideWidget.slideContainerAlign
        }
        commit('ADD_WIDGET', { key, object })
        dispatch('designIframe/snapshot/genSnapshot', {}, { root: true })
        dispatch("designIframe/postToParent", {
          func: "setMode",
          payload: {},
        }, { root: true });

        dispatch("elActive", {
          elementID: ["component", widgetComponent.id],
        });
        dispatch("designIframe/frame/setSlideWidgetActive", {
          component_id: widgetComponent.id,
          slide_section_id: slideSectionID,
          index: indexSlidePage,
        }, { root: true });

        dispatch("designIframe/frame/setFloatFrameActive", {}, { root: true });
        dispatch("designIframe/frame/setFloatFrameHover", {}, { root: true });
        dispatch("designIframe/frame/setSectionHover", {}, { root: true });
        dispatch("designIframe/frame/setSectionActive", {}, { root: true });

    } else if(state.addComponent.widgetInteractive.parentID){
        commit('ADD_WIDGET', { key, object })
        dispatch('designIframe/snapshot/genSnapshot', {}, { root: true })
        dispatch("designIframe/postToParent", {
          func: "setMode",
          payload: {},
        }, { root: true });

        dispatch("designIframe/frame/setFloatFrameActive", {}, { root: true });
        dispatch("designIframe/frame/setFloatFrameHover", {}, { root: true });
        dispatch("designIframe/frame/setSectionHover", {}, { root: true });
        dispatch("designIframe/frame/setSectionActive", {}, { root: true });
        dispatch("elActive", {
          elementID: ["component", widgetComponent.id],
        });
    }
  },
  addWidgetInside({ commit, dispatch }, { object }) {
    commit("ADD_WIDGET_INSIDE", { object });
    dispatch("designIframe/snapshot/genSnapshot", {}, { root: true });
    dispatch(
      "designIframe/postToParent",
      {
        func: "setMode",
        payload: {},
      },
      { root: true }
    );
  },
  addImage({ commit, dispatch }, { key, object }) {
    commit("ADD_WIDGET", { key, object });
    dispatch("designIframe/snapshot/genSnapshot", {}, { root: true });
    dispatch(
      "designIframe/postToParent",
      {
        func: "setMode",
        payload: {},
      },
      { root: true }
    );
    dispatch("elActive", { elementID: ["component", key] });
    dispatch(
      "designIframe/frame/setWidgetActive",
      {
        component_id: key,
      },
      { root: true }
    );
  },
  addGrid({ commit, dispatch }, { key, object }) {
    commit("ADD_GRID", { key, object });
    dispatch("designIframe/snapshot/genSnapshot", {}, { root: true });
    dispatch(
      "designIframe/postToParent",
      {
        func: "setMode",
        payload: {},
      },
      { root: true }
    );
  },
  addNewComponent({ commit, dispatch }, { key, object, parentID }) {
    dispatch('design/blockloading', {}, { root: true })
    commit("ADD_NEW_COMPONENT", { key, object, parentID });
    dispatch("designIframe/snapshot/genSnapshot", {}, { root: true }).then(() => {
      setTimeout(() => dispatch("design/unblockloading", {}, { root: true }), 1500)
    });
    dispatch(
      "designIframe/postToParent",
      {
        func: "setMode",
        payload: {},
      },
      { root: true }
    );
  },
  moveSectionUp({ commit, dispatch }, { id }) {
    commit("MOVE_SECTION_UP", { id });
    dispatch(
      "designIframe/postToParent",
      {
        func: "component/scrollToId",
        payload: { elementID: id },
      },
      { root: true }
    );
    dispatch("designIframe/snapshot/genSnapshot", {}, { root: true });
  },
  moveSectionDown({ commit, dispatch }, { id }) {
    commit("MOVE_SECTION_DOWN", { id });
    dispatch(
      "designIframe/postToParent",
      {
        func: "component/scrollToId",
        payload: { elementID: id },
      },
      { root: true }
    );
    dispatch("designIframe/snapshot/genSnapshot", {}, { root: true });
  },
  moveGridUp({ commit, dispatch }, { id, parent_id }) {
    commit("MOVE_GRID_UP", { id, parent_id });
    dispatch("designIframe/snapshot/genSnapshot", {}, { root: true });
  },
  moveGridDown({ commit, dispatch }, { id, parent_id }) {
    commit("MOVE_GRID_DOWN", { id, parent_id });
    dispatch("designIframe/snapshot/genSnapshot", {}, { root: true });
  },
  moveCellUp({ commit, dispatch }, { id, parent_id }) {
    commit("MOVE_CELL_UP", { id, parent_id });
    dispatch("designIframe/snapshot/genSnapshot", {}, { root: true });
  },
  moveCellDown({ commit, dispatch }, { id, parent_id }) {
    commit("MOVE_CELL_DOWN", { id, parent_id });
    dispatch("designIframe/snapshot/genSnapshot", {}, { root: true });
  },
  elVisible({ commit, dispatch }, { elementID, visible }) {
    commit("elVisible", { elementID, visible });
    dispatch(
      "designIframe/postToParent",
      {
        func: "component/elVisibleChildren",
        payload: { elementID, visible },
      },
      { root: true }
    );
  },
  elHover({ commit, dispatch }, { elementID, lv }) {
    commit("elHover", { elementID, lv });
    dispatch(
      "designIframe/postToParent",
      {
        func: "component/elHoverChildren",
        payload: { elementID, lv },
      },
      { root: true }
    );
  },
  elHoverParent({ commit }, { elementID, lv }) {
    commit("elHover", { elementID, lv });
  },

  elActive({ commit, dispatch }, { elementID, lv = 0 }) {
    commit("elActive", { elementID, lv });

    dispatch(
      "designIframe/postToParent",
      {
        func: "component/elActiveChildren",
        payload: { elementID, lv },
      },
      { root: true }
    );
  },
  elActiveParent({ commit }, { elementID, lv = 0 }) {
    commit("elActive", { elementID, lv });
  },
  // setFloatFrameHover({ commit, dispatch }, { component_id, name }) {
  //
  //   dispatch('setOverlayAction', { component_id, type: 'FLOATFRAME', action: 'HOVER' })
  //   commit('frame/SET_FLOATFRAME_HOVER', { component_id, name })
  // },

  setComponentAction({ commit }, { component_id, type, action }) {
    let position = {
      top: 0,
      height: 0,
      left: 0,
      width: 0,
    };
    const element = document.getElementById(`comp-${component_id}`);
    if (element) {
      const rect = element.getBoundingClientRect();
      position = {
        top: rect.top + document.documentElement.scrollTop + "px",
        height: rect.height + "px",
        left: rect.left + "px",
        width: rect.width + "px",
      };
      commit(
        `designIframe/frame/SET_${type}_${action}_POSITION`,
        { position },
        { root: true }
      );
    } else {
      commit(`designIframe/frame/SET_${type}_${action}_POSITION`, {position}, { root: true });
    }
  },
  setResizeMarginAction({ commit }, { component_id, direction }) {
    const element = document.getElementById(
      `resize-margin-${direction}-${component_id}`
    );
    if (element) {
      const rect = element.getBoundingClientRect();
      const position = {
        top: rect.top + document.documentElement.scrollTop + "px",
        height: rect.height + "px",
        left: rect.left + "px",
        width: rect.width + "px",
      };

      commit(
        `designIframe/frame/SET_RESIZE_MARGIN_HOVER_POSITION`,
        { position },
        { root: true }
      );
    } else {
      commit(
        `designIframe/frame/SET_RESIZE_MARGIN_HOVER`,
        {
          position: {
            top: 0,
            height: 0,
            left: 0,
            width: 0,
          },
          type: "",
          component_id: "",
          label_add_btn: "",
        },
        { root: true }
      );
    }
  },
  setAddBtnAction({ commit }, { component_id, direction }) {
    const element = document.getElementById(
      `resize-margin-${direction}-${component_id}`
    );
    if (element) {
      const rect = element.getBoundingClientRect();
      const position = {
        top: rect.top + document.documentElement.scrollTop + "px",
        height: rect.height + "px",
        left: rect.left + "px",
        width: rect.width + "px",
      };

      commit(
        `designIframe/frame/SET_ADD_BTN_ACTIVE_POSITION`,
        { position },
        { root: true }
      );
    } else {
      commit(
        `designIframe/frame/SET_ADD_BTN_ACTIVE`,
        {
          position: {
            top: 0,
            height: 0,
            left: 0,
            width: 0,
          },
          type: "",
          component_id: "",
          label_add_btn: "",
        },
        { root: true }
      );
    }
  },
  setOverlayAction({ commit }, { component_id, type, action }) {
    const element = document.getElementById(component_id);
    if (element) {
      const rect = element.getBoundingClientRect();
      const position = {
        top: rect.top + document.documentElement.scrollTop + "px",
        height: rect.height + "px",
        left: rect.left + "px",
        width: rect.width + "px",
      };
      commit(
        `designIframe/frame/SET_${type}_${action}_POSITION`,
        { position },
        { root: true }
      );
    } else {
      commit(
        `designIframe/frame/SET_${type}_${action}_POSITION`,
        {
          position: {
            top: "0px",
            height: "0px",
            left: "0px",
            width: "0px",
          },
        },
        { root: true }
      );
    }
  },
  setComponentsKey({ commit }, { key }) {
    commit("SET_COMPONENTS_KEY", key);
  },

  setComponentActivePosition({ dispatch }, { component_id, type, action }) {
    let _action = action.toLowerCase() == 'hover' ? 'Hover' : 'Active'
    let position = default_position
    let a = 0;
    let myInterval = setInterval(() =>{
      let el = document.getElementById(`comp-${component_id}`)
      if (el) {
        position = {
          top: el.getBoundingClientRect().top,
          left: el.getBoundingClientRect().left,
          width: el.getBoundingClientRect().width,
          height: el.getBoundingClientRect().height
        }
        if (type.toLowerCase() == 'cell') {
          dispatch("designIframe/postToParent", {
            func: `component/setCell${_action}Position`,
            payload: { position: position },
          }, { root: true }
          );
        }
        if (type.toLowerCase() == 'widget') {
          dispatch("designIframe/postToParent", {
            func: `component/setWidget${_action}Position`,
            payload: { position: position },
          }, { root: true }
          );
        }
        clearInterval(myInterval);
      }
      if(a >= 1000) {
        if (type.toLowerCase() == 'cell') {
          dispatch("designIframe/postToParent", {
            func: `component/setCell${_action}Position`,
            payload: { position: position },
          }, { root: true }
          );
        }
        if (type.toLowerCase() == 'widget') {
          dispatch("designIframe/postToParent", {
            func: `component/setWidget${_action}Position`,
            payload: { position: position },
          }, { root: true }
          );
        }
        clearInterval(myInterval);
      }
      a = a + 1;
    }, 150);
    
  },
  setSettingPanelWdgProductCateActiveId({ commit }, { id }) {
    commit('SET_SETTING_PANEL_WDG_PRODUCT_CATE_ACTIVE_ID',{ id })
  },
  getWidgetTableActiveHeight({ dispatch }, { widgetId }) {
    let wdg = document.getElementById(`comp-${widgetId}`)
    if (wdg) {
      let tableContainer = wdg.getElementsByClassName('table-container');
      if (tableContainer.length > 0) {
        let height = Math.round(tableContainer[0].getBoundingClientRect().height)
        dispatch("designIframe/postToParent", {
          func: 'component/setWidgetTableActiveHeight',
          payload: { height },
        }, { root: true });
      }
    }
  },
  setWidgetTableActiveHeight({ dispatch }, { height }) {
    dispatch("designIframe/postToParent", {
      func: 'component/setWidgetTableActiveHeight',
      payload: { height },
    }, { root: true });
  },
  setWidgetTableCellActiveId({ commit }, { widgetId, cellId, selections }) {
    commit("SET_WIDGET_TABLE_CELL_ACTIVE_ID", { widgetId, cellId, selections });
  },

};
const mutations = {
  SET_COMPONENTS_KEY(state, key) {
    state.componentsKey = key;
  },
  MOVE_SECTION_UP(_, { id }) {
    const componentsID =
      this.state.designIframe.metadata.screen.pages.props.components
        .CONTENT_CONTAINER.componentsID;
    const index = componentsID.indexOf(id);
    if (index > 0) {
      const temp = componentsID[index - 1];
      componentsID[index - 1] = componentsID[index];
      componentsID[index] = temp;
    }
    this.state.designIframe.metadata.screen.pages.props.components.CONTENT_CONTAINER.componentsID =
      JSON.parse(
        JSON.stringify(
          this.state.designIframe.metadata.screen.pages.props.components
            .CONTENT_CONTAINER.componentsID
        )
      );
  },
  MOVE_SECTION_DOWN(_, { id }) {
    const componentsID =
      this.state.designIframe.metadata.screen.pages.props.components
        .CONTENT_CONTAINER.componentsID;
    const index = componentsID.indexOf(id);
    if (index < componentsID.length - 1) {
      const temp = componentsID[index + 1];
      componentsID[index + 1] = componentsID[index];
      componentsID[index] = temp;
    }
    this.state.designIframe.metadata.screen.pages.props.components.CONTENT_CONTAINER.componentsID =
      JSON.parse(
        JSON.stringify(
          this.state.designIframe.metadata.screen.pages.props.components
            .CONTENT_CONTAINER.componentsID
        )
      );
  },
  MOVE_GRID_UP(_, { id, parent_id }) {
    const components =
      this.state.designIframe.metadata.screen.pages.assets.components;

    const componentsID = components[parent_id].componentsID;
    const index = componentsID.indexOf(id);

    //---------- start sync Grid Margin ----------//
    if (index > -1 && components[parent_id].componentsID.length > 1) { // more than 1 grid
      const isGridSecond = index == 1;
      const isGridLast = index == components[parent_id].componentsID.length - 1;
      if (isGridSecond) { // Order Second grid Up
        const topSectionMargin = components[parent_id].style.marginTop;
        const gridID = componentsID[index]
        const firstGridID = components[parent_id].componentsID[0]
        this.state.designIframe.metadata.screen.pages.assets.components[firstGridID].style.marginTop = this.state.designIframe.metadata.screen.pages.assets.components[gridID].style.marginTop;
        this.state.designIframe.metadata.screen.pages.assets.components[gridID].style.marginTop = topSectionMargin;
      } 
      
      if (isGridLast) { // Order Last grid Up
        const bottomSectionMargin = components[parent_id].style.marginBottom;
        // const gridID = components[parent_id].componentsID[index]
        const previousGridID = components[parent_id].componentsID[index - 1]
        this.state.designIframe.metadata.screen.pages.assets.components[previousGridID].style.marginBottom = bottomSectionMargin;
      }
    }
    //---------- end sync Grid Margin ----------//

    if (index > 0) { // swap
      const temp = componentsID[index - 1];
      componentsID[index - 1] = componentsID[index];
      componentsID[index] = temp;
    }
    
    // Update Bottom Margin //
    componentsID.map((id, index) => {
      if (componentsID.length > 1 && index != componentsID.length - 1) { // not Last
        const nextGridID = componentsID[index + 1]
        this.state.designIframe.metadata.screen.pages.assets.components[id].style.marginBottom = components[nextGridID].style.marginTop;
      }
    })

    this.state.designIframe.metadata.screen.pages.assets.components[
      parent_id
    ].componentsID = JSON.parse(
      JSON.stringify(
        this.state.designIframe.metadata.screen.pages.assets.components[
          parent_id
        ].componentsID
      )
    );
  },
  MOVE_GRID_DOWN(_, { id, parent_id }) {
    const components =
      this.state.designIframe.metadata.screen.pages.assets.components;

    const componentsID = components[parent_id].componentsID;
    const index = componentsID.indexOf(id);

    //---------- start sync Grid Margin ----------//
    if (index > -1 && components[parent_id].componentsID.length > 1) { // more than 1 grid in section
      const isGridFirst = index == 0;
      const isGridSecondLast = components[parent_id].componentsID.length > 1 && index == components[parent_id].componentsID.length - 2;
      if (isGridFirst) { // Order First grid Down
        const topSectionMargin = components[parent_id].style.marginTop;
        const gridID = components[parent_id].componentsID[index]
        const nextGridID = components[parent_id].componentsID[index+1]
        this.state.designIframe.metadata.screen.pages.assets.components[gridID].style.marginTop = this.state.designIframe.metadata.screen.pages.assets.components[nextGridID].style.marginTop;
        this.state.designIframe.metadata.screen.pages.assets.components[nextGridID].style.marginTop = topSectionMargin;
      }
      
      if (isGridSecondLast) { // Order Second Last grid Down
        const bottomSectionMargin = components[parent_id].style.marginBottom;
        const gridID = components[parent_id].componentsID[index]
        this.state.designIframe.metadata.screen.pages.assets.components[gridID].style.marginBottom = bottomSectionMargin;
      }
    }
    //---------- end sync Grid Margin ----------//

    if (index < componentsID.length - 1) {
      const temp = componentsID[index + 1];
      componentsID[index + 1] = componentsID[index];
      componentsID[index] = temp;
    }

    // Update Bottom Margin //
    componentsID.map((id, index) => {
      if (componentsID.length > 1 && index != componentsID.length - 1) { // not Last
        const nextGridID = componentsID[index + 1]
        this.state.designIframe.metadata.screen.pages.assets.components[id].style.marginBottom = components[nextGridID].style.marginTop;
      }
    })

    this.state.designIframe.metadata.screen.pages.assets.components[
      parent_id
    ].componentsID = JSON.parse(
      JSON.stringify(
        this.state.designIframe.metadata.screen.pages.assets.components[
          parent_id
        ].componentsID
      )
    );
  },
  MOVE_CELL_UP(_, { id, parent_id }) {
    const componentsID =
      this.state.designIframe.metadata.screen.pages.assets.components[parent_id]
        .componentsIDMobile;
    const index = componentsID.indexOf(id);
    if (index > 0) {
      const temp = componentsID[index - 1];
      componentsID[index - 1] = componentsID[index];
      componentsID[index] = temp;
    }
    this.state.designIframe.metadata.screen.pages.assets.components[
      parent_id
    ].componentsIDMobile = JSON.parse(
      JSON.stringify(
        this.state.designIframe.metadata.screen.pages.assets.components[
          parent_id
        ].componentsIDMobile
      )
    );
  },
  MOVE_CELL_DOWN(_, { id, parent_id }) {
    const componentsID =
      this.state.designIframe.metadata.screen.pages.assets.components[parent_id]
        .componentsIDMobile;
    const index = componentsID.indexOf(id);
    if (index < componentsID.length - 1) {
      const temp = componentsID[index + 1];
      componentsID[index + 1] = componentsID[index];
      componentsID[index] = temp;
    }
    this.state.designIframe.metadata.screen.pages.assets.components[
      parent_id
    ].componentsIDMobile = JSON.parse(
      JSON.stringify(
        this.state.designIframe.metadata.screen.pages.assets.components[
          parent_id
        ].componentsIDMobile
      )
    );
  },
  ADD_SECTION(state, { key, object }) {
    const componentsID =
      this.state.designIframe.metadata.screen.pages.props.components
        .CONTENT_CONTAINER.componentsID;
    this.state.designIframe.metadata.screen.pages.assets.components = {
      ...this.state.designIframe.metadata.screen.pages.assets.components,
      ...object,
    };

    const { sectionID, direction } = state.addComponent.section;

    if (sectionID) {
      const position = direction == "up" ? -1 : 0;
      const index = componentsID.indexOf(sectionID);
      componentsID.splice(index + position + 1, 0, key);
    } else {
      const isSectionPage = componentsID.indexOf("SECTION_PAGE");
      if (isSectionPage != -1) {
        componentsID.pop();
        componentsID.push(key);
        componentsID.push("SECTION_PAGE");
      } else {
        componentsID.push(key);
      }
    }
    this.state.designIframe.metadata.screen.pages = JSON.parse(
      JSON.stringify(this.state.designIframe.metadata.screen.pages)
    );
    state.addComponent.section = {};
  },
  ADD_COMPONENT(_, { key, prevKey, object, parent_id, prevIndex }) {
    const componentsID =
      this.state.designIframe.metadata.screen.pages.assets.components[parent_id]
        .componentsID;
    this.state.designIframe.metadata.screen.pages.assets.components = {
      ...this.state.designIframe.metadata.screen.pages.assets.components,
      ...object,
    };
    if (prevKey) {
      prevIndex = componentsID.indexOf(prevKey);
    } else if (prevIndex == undefined && prevKey == undefined) {
      prevIndex = componentsID.length - 1;
    }
    componentsID.splice(prevIndex + 1, 0, key);
    this.state.designIframe.metadata.screen.pages = JSON.parse(
      JSON.stringify(this.state.designIframe.metadata.screen.pages)
    );
  },
  ADD_WIDGET(state, { key, object }) {
    const {
      cellID,
    } = state.addComponent.widget;
    const {
      slideContainerID,
    } = state.addComponent.slideWidget;
    const widgetInteractiveID = state.addComponent.widgetInteractive.parentID
    
    if (cellID) { // Cell
      const { direction,
        widgetID,
        attribute = "componentsID",
      } = state.addComponent.widget;
      const componentsID =
        this.state.designIframe.metadata.screen.pages.assets.components[cellID][
          attribute
        ];
      this.state.designIframe.metadata.screen.pages.assets.components = {
        ...this.state.designIframe.metadata.screen.pages.assets.components,
        ...object,
      };
      const widgetIndex = componentsID.indexOf(widgetID);

      if (direction == "top") {
        componentsID.splice(widgetIndex, 0, key);
      } else {
        componentsID.splice(widgetIndex + 1, 0, key);
      }
      this.state.designIframe.metadata.screen.pages = JSON.parse(
        JSON.stringify(this.state.designIframe.metadata.screen.pages)
      );
      state.addComponent.widget = {};
    } else if (slideContainerID) { // Slide Container
      const {
        slideContainerID,
        slideWidgetID,
        direction,
        attribute = "componentsID",
      } = state.addComponent.slideWidget
      const componentsID =
        this.state.designIframe.metadata.screen.pages.assets.components[slideContainerID][
          attribute
        ];
      this.state.designIframe.metadata.screen.pages.assets.components = {
        ...this.state.designIframe.metadata.screen.pages.assets.components,
        ...object,
      };
      const widgetIndex = componentsID.indexOf(slideWidgetID);

      if (direction == "top") {
        componentsID.splice(widgetIndex, 0, key);
      } else {
        componentsID.splice(widgetIndex + 1, 0, key);
      }

      this.state.designIframe.metadata.screen.pages = JSON.parse(
        JSON.stringify(this.state.designIframe.metadata.screen.pages)
      );
      state.addComponent.slideWidget = {};
    } else if (widgetInteractiveID){
      const { 
        direction,
        parentID,
        attribute = "componentsID",
      } = state.addComponent.widgetInteractive;

      const componentsID = this.state.designIframe.metadata.screen.pages.assets.components[parentID][attribute];
      const widgetIndex = componentsID.indexOf(parentID);

      if (direction == "top") {
        componentsID.splice(widgetIndex, 0, key);
      } else {
        componentsID.splice(widgetIndex + 1, 0, key);
      }

      this.state.designIframe.metadata.screen.pages.assets.components = {
        ...this.state.designIframe.metadata.screen.pages.assets.components,
        ...object,
      };
      this.state.designIframe.metadata.screen.pages = JSON.parse(
        JSON.stringify(this.state.designIframe.metadata.screen.pages)
      );
      state.addComponent.widgetInteractive = {};
    }
  },
  ADD_WIDGET_INSIDE(_, { object }) {
    this.state.designIframe.metadata.screen.pages.assets.components = {
      ...this.state.designIframe.metadata.screen.pages.assets.components,
      ...object,
    };
    this.state.designIframe.metadata.screen.pages = JSON.parse(
      JSON.stringify(this.state.designIframe.metadata.screen.pages)
    );
  },

  ADD_GRID(state, { key, object }) {
    const { gridID, sectionID, direction, isFirst, isLast } = state.addComponent.grid;

    // ----- start SET DEFAULT GRID MARGIN ----- //
    if(gridID) {
      if (isFirst && direction == 'top') { // Case Add Top First Grid
        const gridFirstMargin = this.state.designIframe.metadata.screen.pages.assets.components[gridID].style.marginTop;
        
        object[key].style.marginTop = gridFirstMargin;
        object[key].style.marginBottom = 30;
        this.state.designIframe.metadata.screen.pages.assets.components[gridID].style.marginTop = 30;
        // SWAP margin first grid and margin between grid
      } else if (isLast && direction == 'bottom') { // Case Add Bottom Last Grid
        const gridBottomMargin = this.state.designIframe.metadata.screen.pages.assets.components[gridID].style.marginBottom;

        this.state.designIframe.metadata.screen.pages.assets.components[sectionID].style.marginBottom = gridBottomMargin;
        object[key].style.marginBottom = gridBottomMargin;
        object[key].style.marginTop = 30;
        this.state.designIframe.metadata.screen.pages.assets.components[gridID].style.marginBottom = 30;
        // SWAP margin last grid and margin between grid
      } else {
        const componentsID = this.state.designIframe.metadata.screen.pages.assets.components[sectionID].componentsID;
        const gridIndex = componentsID.indexOf(gridID);
        this.state.designIframe.metadata.screen.pages.assets.components[componentsID[gridIndex-1]].style.marginBottom = 30;
        object[key].style.marginTop = 30;
      }
    } else { // Not have grid in section
      object[key].style.marginTop = this.state.designIframe.metadata.screen.pages.assets.components[sectionID].style.marginTop;
      object[key].style.marginBottom = this.state.designIframe.metadata.screen.pages.assets.components[sectionID].style.marginBottom;
    }
      // ----- end SET DEFAULT GRID MARGIN ----- //

    const componentsID =
      this.state.designIframe.metadata.screen.pages.assets.components[sectionID]
        .componentsID;
    this.state.designIframe.metadata.screen.pages.assets.components = {
      ...this.state.designIframe.metadata.screen.pages.assets.components,
      ...object,
    };
    const gridIndex = componentsID.indexOf(gridID);
    if (direction == "top") {
      componentsID.splice(gridIndex, 0, key);
    } else {
      componentsID.splice(gridIndex + 1, 0, key);
    }

    this.state.designIframe.metadata.screen.pages = JSON.parse(
      JSON.stringify(this.state.designIframe.metadata.screen.pages)
    );
    state.addComponent.grid = {};
  },
  ADD_NEW_COMPONENT(state, { key, object, parentID }) {
    const parentComponentsID =
      this.state.designIframe.metadata.screen.pages.assets.components[parentID]
        .componentsID;
    this.state.designIframe.metadata.screen.pages.assets.components = {
      ...this.state.designIframe.metadata.screen.pages.assets.components,
      ...object,
    };
    // const findIndex = parentComponentsID.indexOf(key)

    parentComponentsID.push(key);

    this.state.designIframe.metadata.screen.pages = JSON.parse(
      JSON.stringify(this.state.designIframe.metadata.screen.pages)
    );
    state.addComponent.component = {};
  },
  REMOVE_SECTION(_, { id }) {
    const index =
      this.state.designIframe.metadata.screen.pages.props.components.CONTENT_CONTAINER.componentsID.indexOf(
        id
      );
    this.state.designIframe.metadata.screen.pages.props.components.CONTENT_CONTAINER.componentsID.splice(
      index,
      1
    );
    this.state.designIframe.metadata.screen.pages.assets.components[id] =
      undefined;
    this.state.designIframe.metadata.screen.pages = JSON.parse(
      JSON.stringify(this.state.designIframe.metadata.screen.pages)
    );
  },

  REMOVE_COMPONENT(_, { id, parent_id }) {
    const components =
      this.state.designIframe.metadata.screen.pages.assets.components;
    const childAttr = Object.keys(components[parent_id]).filter(
      (attr) => attr.search("componentsID") > -1
    );

    childAttr.forEach((attr) => {
      const index = components[parent_id][attr].indexOf(id);

      //---------- start sync Grid Margin ----------//
      const is_grid = id.search(GRID.prefixKey) == 0;
      if (is_grid && index > -1 && components[parent_id][attr].length > 1) {
        const isGridFirst = index == 0;
        const isGridLast = index == components[parent_id][attr].length - 1;
        if (isGridFirst) { // REMOVE First grid and swap top margin to next grid
          const topSectionMargin = components[parent_id].style.marginTop;
          const nextGridID = components[parent_id][attr][index + 1]
          this.state.designIframe.metadata.screen.pages.assets.components[nextGridID].style.marginTop = topSectionMargin;
        } else if (isGridLast) { // REMOVE Last grid and swap Bottom margin to previous grid
          const bottomSectionMargin = components[parent_id].style.marginBottom;
          const previousGridID = components[parent_id][attr][index - 1]
          this.state.designIframe.metadata.screen.pages.assets.components[previousGridID].style.marginBottom = bottomSectionMargin;
        } else { // Between Case Update Previous grid marginBottom By Next grid marginTop
          const previousGridID = components[parent_id][attr][index - 1]
          const nextGridID = components[parent_id][attr][index + 1]
          const topNextGridMargin = components[nextGridID].style.marginTop;
          this.state.designIframe.metadata.screen.pages.assets.components[previousGridID].style.marginBottom = topNextGridMargin;
        }
      }
      //---------- end sync Grid Margin ----------//

      if (index > -1) {
        components[parent_id][attr].splice(index, 1);
        components[id] = undefined;
        this.state.designIframe.metadata.screen.pages = JSON.parse(
          JSON.stringify(this.state.designIframe.metadata.screen.pages)
        );
      }
    });
  },
  elVisible(state, { elementID, visible }) {
    state.elVisible[elementID] = visible;
  },
  elHover(state, { elementID }) {
    if (Array.isArray(elementID)) {
      state.elHoverID = [...elementID];
    } else {
      state.elHoverID = [elementID];
    }
  },
  elActive(state, { elementID, lv = 0 }) {
    if (Array.isArray(elementID)) {
      const parent = findParentComponent(
        this.state.designIframe.metadata.screen.pages.assets.components,
        elementID[1]
      );
      state.elActiveParentID = [
        ...state.elActiveID.slice(0, lv),
        ...parent,
        ...elementID,
      ];
      state.elActiveID = [
        ...state.elActiveID.slice(0, lv),
        ...elementID,
      ].filter((i) => !!i);
    } else {
      const parent = findParentComponent(
        this.state.designIframe.metadata.screen.pages.assets.components,
        elementID
      );
      state.elActiveParentID = [
        ...state.elActiveID.slice(0, lv),
        ...parent,
        elementID,
      ];
      state.elActiveID = [...state.elActiveID.slice(0, lv), elementID].filter(
        (i) => !!i
      );
    }
  },
  SET_SETTING_PANEL_WDG_PRODUCT_CATE_ACTIVE_ID(state, { id }) {
    state.settingPanelWdgProductCateActiveId = id;
  },
  SET_WIDGET_TABLE_CELL_ACTIVE_ID(state, { widgetId, cellId, selections }) {
    state.widgetTableCellActiveId.widgetId = widgetId;
    state.widgetTableCellActiveId.cellId = cellId;
    state.widgetTableCellActiveId.selections = selections;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
